import React, { useEffect, useRef, useState } from 'react';

import { updateRule } from 'src/services/rules';

import Toggle from 'src/views/components/Toggle';

const EnableToggle = ({ id, enabled, isV3Rule }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const mounted = useRef(true);
  useEffect(() => () => { mounted.current = false; }, []);

  const toggle = () => {
    const newVal = !enabled;
    setError(false);
    setLoading(true);
    updateRule(id, { enabled: newVal })
      .then(() => {
        if (mounted.current) setLoading(false);
      })
      .catch(() => {
        if (mounted.current) setError(true);
        if (mounted.current) setLoading(false);
      });
  };

  return (
    <div data-cy="enable-rule-toggle">
      <Toggle
        isError={error}
        isDisabled={loading || isV3Rule}
        isChecked={ loading ? !enabled : enabled }
        onChange={toggle}
      />
    </div>
  );
};

export default EnableToggle;
